
import axios from 'axios';

let config = {
    baseURL: process.env.REACT_APP_URL,
    withCredentials: true
};
const Axios = axios.create( config );

export default Axios;
